// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wn-stale-banner .wn-stale-alert {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin: 0;
  border-radius: 0;
  border: none;
  border-bottom: 1px solid #ededed;
}
.wn-stale-banner .wn-stale-icon {
  font-size: 1.25rem;
  flex-shrink: 0;
}
.wn-stale-banner .wn-stale-content strong {
  display: block;
  margin-bottom: 0.25rem;
}
.wn-stale-banner .wn-stale-content p {
  margin: 0 0 0.25rem;
  font-size: 0.85rem;
}
.wn-stale-banner .wn-stale-content .wn-stale-hint {
  color: #a3a3a3;
  font-style: italic;
}
.row .col label {
  color: #4b58a6;
  font-weight: bold;
  padding-right: 3%;
}
h2 {
  background: #e1dbe2;
  margin: 0;
  padding: 15px;
  font-size: 16px;
  font-weight: 400;
  justify-content: space-between;
  align-items: center;
}
.no-fraud {
  font-weight: 600;
  text-align: center;
  padding: 5px;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
img.overlay {
  /* height: 900px; */
  width: 99%;
  box-shadow: 1px 2px 3px #89889c;
  border: 2px solid rgba(25, 4, 101, 0.31);
}
button {
  border-radius: 0;
  border: 1px solid rgba(128, 0, 128, 0.31);
}
button.overlays {
  background-color: rgba(247, 173, 67, 0.76);
}
div.alert {
  border-radius: 0 !important;
  text-align: center;
}
/* ===== Refactored Work Number layout ===== */
.wn-record + .wn-record {
  margin-top: 24px;
  padding-top: 16px;
  border-top: 2px dashed rgba(75, 88, 166, 0.25);
}
.wn-section {
  padding: 12px 14px;
  margin-bottom: 12px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  background: #fff;
}
.wn-section .row {
  margin-bottom: 6px;
}
.wn-section .row:last-child {
  margin-bottom: 0;
}
.wn-section-title {
  margin: 0 0 10px 0;
  padding-bottom: 6px;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #4b58a6;
  border-bottom: 1px solid rgba(75, 88, 166, 0.2);
}
/* Highlighted: employment header */
.wn-employment-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(90deg, #eef0fb 0%, #f7f5fb 100%);
  border-left: 4px solid #4b58a6;
}
.wn-employment-header .wn-employer-name {
  font-size: 18px;
  font-weight: 700;
  color: #2e3a7a;
}
.wn-employment-header .wn-employee-name {
  font-size: 14px;
  color: #444;
  margin-top: 2px;
}
.wn-employment-header .wn-position {
  color: #666;
  font-style: italic;
}
/* Highlighted: pay & income */
.wn-pay-section {
  background: #fffaf1;
  border-left: 4px solid #f7ad43;
}
.wn-income-section {
  background: #f1faf3;
  border-left: 4px solid #4caf50;
}
.wn-emphasize {
  font-weight: 700;
  color: #2e3a7a;
}
/* Status badge */
.wn-status-badge {
  padding: 6px 14px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #fff;
  background: #888;
}
.wn-status-badge.status-active {
  background: #2e8b57;
}
.wn-status-badge.status-inactive {
  background: #c0392b;
}
.wn-status-badge.status-other {
  background: #888;
}
/* Annual comp table */
.wn-annual-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.wn-annual-table th,
.wn-annual-table td {
  padding: 6px 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
.wn-annual-table th {
  text-align: left;
  color: #4b58a6;
  background: #f4f3f9;
}
.wn-annual-table .text-right {
  text-align: right;
}
small {
  color: #777;
  font-size: 11px;
  margin-left: 2px;
}
.wn-ref-value {
  -webkit-user-select: all;
          user-select: all;
  font-variant-numeric: tabular-nums;
  word-break: break-all;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared-components-module/income-stream-components/work-number/work-number.component.less"],"names":[],"mappings":"AAEA;EAEI,aAAA;EACA,uBAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;EACA,YAAA;EACA,gCAAA;AAFJ;AANA;EAUmB,kBAAA;EAAoB,cAAA;AAAvC;AAVA;EAYa,cAAA;EAAgB,sBAAA;AAE7B;AAdA;EAaQ,mBAAA;EAAqB,kBAAA;AAK7B;AAlBA;EAcqB,cAAA;EAAgB,kBAAA;AAQrC;AAJA;EACI,cAAA;EACA,iBAAA;EACA,iBAAA;AAMJ;AAJA;EACI,mBAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,mBAAA;AAMJ;AAHA;EACI,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,oCAAA;AAKJ;AAFA;EAIE,mBAAmB;EAFjB,UAAA;EACA,+BAAA;EACA,wCAAA;AAIJ;AAAA;EACI,gBAAA;EACA,yCAAA;AAEJ;AADI;EACI,0CAAA;AAGR;AACA;EACK,2BAAA;EACD,kBAAA;AACJ;AACA,8CAA8C;AAE9C;EAEQ,gBAAA;EACA,iBAAA;EACA,8CAAA;AADR;AAKA;EACI,kBAAA;EACA,mBAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;AAHJ;AAFA;EAQQ,kBAAA;AAHR;AAIQ;EAAe,gBAAA;AADvB;AAKA;EACI,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,+CAAA;AAHJ;AACA,mCAAmC;AAMnC;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,4DAAA;EACA,8BAAA;AAJJ;AADA;EAQQ,eAAA;EACA,gBAAA;EACA,cAAA;AAJR;AANA;EAaQ,eAAA;EACA,WAAA;EACA,eAAA;AAJR;AAXA;EAkBQ,WAAA;EACA,kBAAA;AAJR;AACA,8BAA8B;AAQ9B;EACI,mBAAA;EACA,8BAAA;AANJ;AAQA;EACI,mBAAA;EACA,8BAAA;AANJ;AASA;EACI,gBAAA;EACA,cAAA;AAPJ;AACA,iBAAiB;AAUjB;EACI,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;AARJ;AAUI;EAAoB,mBAAA;AAPxB;AAQI;EAAoB,mBAAA;AALxB;AAMI;EAAoB,gBAAA;AAHxB;AACA,sBAAsB;AAMtB;EACI,WAAA;EACA,yBAAA;EACA,eAAA;AAJJ;AACA;;EAMQ,iBAAA;EACA,4CAAA;AAHR;AAJA;EAUQ,gBAAA;EACA,cAAA;EACA,mBAAA;AAHR;AATA;EAckB,iBAAA;AAFlB;AAKA;EACI,WAAA;EACA,eAAA;EACA,gBAAA;AAHJ;AAMA;EACI,wBAAA;UAAA,gBAAA;EACA,kCAAA;EACA,qBAAA;AAJJ","sourcesContent":["@import (reference) url('../../../../styles.less');\n\n.wn-stale-banner {\n  .wn-stale-alert {\n    display: flex;\n    align-items: flex-start;\n    gap: 0.75rem;\n    margin: 0;\n    border-radius: 0;\n    border: none;\n    border-bottom: 1px solid #ededed;\n  }\n  .wn-stale-icon { font-size: 1.25rem; flex-shrink: 0; }\n  .wn-stale-content {\n    strong { display: block; margin-bottom: 0.25rem; }\n    p { margin: 0 0 0.25rem; font-size: 0.85rem; }\n    .wn-stale-hint { color: #a3a3a3; font-style: italic; }\n  }\n}\n\n.row .col label{\n    color: #4b58a6;\n    font-weight: bold;\n    padding-right: 3%;\n}\nh2{\n    background: #e1dbe2;\n    margin:0;\n    padding: 15px;\n    font-size: 16px;\n    font-weight: 400;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.no-fraud{\n    font-weight: 600;\n    text-align: center;\n    padding: 5px;\n    border: 1px solid rgba(0, 0, 0, .1);\n}\n\nimg.overlay{\n    /* height: 900px; */\n    width: 99%;\n    box-shadow: 1px 2px 3px #89889c;\n    border: 2px solid rgba(25,4, 101, 0.31);\n    \n}\n\nbutton {\n    border-radius: 0;\n    border: 1px solid rgba(128,0,128,0.31);\n    &.overlays{\n        background-color: rgba(247,173,67,0.76);\n    }\n}\n\ndiv.alert{\n     border-radius: 0 !important;\n    text-align: center;\n}\n\n/* ===== Refactored Work Number layout ===== */\n.wn-record {\n    + .wn-record {\n        margin-top: 24px;\n        padding-top: 16px;\n        border-top: 2px dashed rgba(75, 88, 166, 0.25);\n    }\n}\n\n.wn-section {\n    padding: 12px 14px;\n    margin-bottom: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.08);\n    border-radius: 4px;\n    background: #fff;\n\n    .row {\n        margin-bottom: 6px;\n        &:last-child { margin-bottom: 0; }\n    }\n}\n\n.wn-section-title {\n    margin: 0 0 10px 0;\n    padding-bottom: 6px;\n    font-size: 13px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: #4b58a6;\n    border-bottom: 1px solid rgba(75, 88, 166, 0.2);\n}\n\n/* Highlighted: employment header */\n.wn-employment-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background: linear-gradient(90deg, #eef0fb 0%, #f7f5fb 100%);\n    border-left: 4px solid #4b58a6;\n\n    .wn-employer-name {\n        font-size: 18px;\n        font-weight: 700;\n        color: #2e3a7a;\n    }\n    .wn-employee-name {\n        font-size: 14px;\n        color: #444;\n        margin-top: 2px;\n    }\n    .wn-position {\n        color: #666;\n        font-style: italic;\n    }\n}\n\n/* Highlighted: pay & income */\n.wn-pay-section {\n    background: #fffaf1;\n    border-left: 4px solid #f7ad43;\n}\n.wn-income-section {\n    background: #f1faf3;\n    border-left: 4px solid #4caf50;\n}\n\n.wn-emphasize {\n    font-weight: 700;\n    color: #2e3a7a;\n}\n\n/* Status badge */\n.wn-status-badge {\n    padding: 6px 14px;\n    border-radius: 999px;\n    font-size: 12px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    color: #fff;\n    background: #888;\n\n    &.status-active   { background: #2e8b57; }\n    &.status-inactive { background: #c0392b; }\n    &.status-other    { background: #888; }\n}\n\n/* Annual comp table */\n.wn-annual-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 13px;\n\n    th, td {\n        padding: 6px 10px;\n        border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n    }\n    th {\n        text-align: left;\n        color: #4b58a6;\n        background: #f4f3f9;\n    }\n    .text-right { text-align: right; }\n}\n\nsmall {\n    color: #777;\n    font-size: 11px;\n    margin-left: 2px;\n}\n\n.wn-ref-value {\n    user-select: all;\n    font-variant-numeric: tabular-nums;\n    word-break: break-all;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
